<template>
  <div id="show">
    <img :src="imgUrl" alt="">
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        imgUrl:'',
      }
    },
    mounted() {
      this.imgUrl = this.$route.query.url;
    }
  }
</script>

<style scoped>
  #show{
    background: black;
    display: flex;
    align-items: center;
  }
  #show>img{width: 100%;}
</style>
